import Utilities from './Utilities';

export function newsletterRegionaut() {
  const regionautClose = document.querySelector('.js-newsletterRegionaut-close') as HTMLElement;
  const notice = document.querySelector('.js-newsletterRegionaut-notice') as HTMLElement;
  const regionaut = document.querySelector('.js-newsletterRegionaut') as HTMLElement;
  const regionautWrapper = document.querySelector('.js-newsletterRegionaut__wrapper') as HTMLElement;
  if (!regionaut || !regionautClose || !notice || !regionautWrapper) {
    return;
  }

  setTimeout(
    () => {
      regionautWrapper.classList.add('newsletterRegionaut__wrapper--leave');
      regionautWrapper.addEventListener('animationend', () => {regionaut.remove(); }, {once: true});
    },
    90000);

  const cookieDismissed = 'regionautNewsletterDismissed';
  if (Utilities.getCookie(cookieDismissed)) {
    regionaut.remove();
  }

  regionautClose.addEventListener('click', () => {
    regionautWrapper.classList.add('newsletterRegionaut__wrapper--leave');
    regionautWrapper.addEventListener('animationend', () => {regionaut.remove(); }, {once: true});
    const sevenDays = 7 * 24;
    Utilities.setCookie(cookieDismissed, 'true', sevenDays);
  });

  notice.addEventListener('click', () => {
    const oneMinute = 1 / 60;
    Utilities.setCookie(cookieDismissed, 'true', oneMinute);
    const newsletterUrl = 'https://www.region-stuttgart.org/de/digital/#c1692';
    window.location.href = newsletterUrl;
  });
}
